export interface CountryNumber {
	isoCode: string;
	dialCode: string;
}

export const countries: CountryNumber[] = [
	{
		isoCode: 'sa',
		dialCode: '+966',
	},
	{
		isoCode: 'eg',
		dialCode: '+20',
	},
];
